import { ClientType } from "@usher/pe-client-front-end-lib"
import { Fragment } from "react/jsx-runtime"
import { getLink } from "../getLink"
import { GET_LINKS } from "../links"
import { VerificationStep } from "../VerificationStep"

interface Props {
  verify_flags: number
  type: string
}
export const CorporateSteps = ({ type }: Props) => {
  return (
    <Fragment>
      {GET_LINKS(ClientType.Coroporate, type).map(({ title, route }) => (
        <VerificationStep title={title} active={1} href={getLink(type, route, true)} />
      ))}
    </Fragment>
  )
}
